const QUERY_PARAM = {
    order_info: "order_info_id",
    intake_order: "intake_order_id",
    intake_document: "intake_document_id",
};
const PAYLOAD_KEY = {
    order_info: "orderInfoId",
    intake_order: "intakeOrderId",
    intake_document: "intakeDocumentId",
};
export function anchorQueryParams(anchor) {
    return { [QUERY_PARAM[anchor.type]]: anchor.id };
}
export function anchorPayload(anchor) {
    return { [PAYLOAD_KEY[anchor.type]]: anchor.id };
}
export function anchorFromCall(call) {
    if (!call)
        return null;
    if (call.orderInfo)
        return { type: "order_info", id: call.orderInfo };
    if (call.intakeOrder)
        return { type: "intake_order", id: call.intakeOrder };
    if (call.intakeDocumentKey)
        return { type: "intake_document", id: call.intakeDocumentKey };
    return null;
}
export function templateFitsSurface(template, surface) {
    const surfaces = template.surfaces;
    return !Array.isArray(surfaces) || surfaces.length === 0 || surfaces.includes(surface);
}
export function offeredTemplates(templates, surface) {
    return (templates || []).filter((t) => (t.uiFields || []).length && t.provisioned && templateFitsSurface(t, surface));
}
